import Reveal from "@/components/Reveal";
import MutedVideo from "@/components/MutedVideo";
import ShareButton from "@/components/ShareButton";
import { GALLERY } from "@/data/site";

export default function Gallery() {
    return (
        <section id="gallery" data-testid="gallery-section" className="py-16 md:py-24 lg:py-32 bg-[#F7F2E9]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
                    <div className="max-w-2xl">
                        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C59B27]">Gallery</p>
                        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#3D2318]">
                            See Our Creations
                        </h2>
                        <p className="mt-4 text-base sm:text-lg text-[#6B4A3E] font-light leading-relaxed">
                            A peek inside the kitchen — fresh batches, custom designs, and treats made with love.
                        </p>
                    </div>
                    <ShareButton title="Annabells Cupcakes and More — Gallery" path="/#gallery" testId="gallery-share" className="self-start sm:self-auto shrink-0" />
                </Reveal>

                <div className="mt-14 grid grid-cols-2 md:grid-cols-4 auto-rows-[160px] sm:auto-rows-[200px] gap-4" data-testid="gallery-grid">
                    {GALLERY.map((item, i) => (
                        <Reveal key={i} delay={(i % 4) * 0.08} className={`${item.span} col-span-1 row-span-1`}>
                            <figure className="group relative h-full w-full overflow-hidden rounded-2xl" data-testid={`gallery-item-${i}`}>
                                {item.video ? (
                                    <MutedVideo video={item.video} testId={`gallery-video-${i}`} className="h-full w-full object-cover" />
                                ) : (
                                    <img
                                        src={item.src}
                                        alt={item.alt}
                                        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-108"
                                        style={{ transform: "scale(1.01)" }}
                                    />
                                )}
                                <figcaption className="absolute inset-0 flex items-end bg-gradient-to-t from-[#2C180F]/70 via-transparent to-transparent p-4 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                                    <span className="text-xs font-medium text-[#FFFDF9]">{item.alt}</span>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
